(() => {
  'use strict';
  const configNode = document.getElementById('sw-cart-ux-config');
  if (!configNode) return;
  const c = JSON.parse(configNode.textContent);
  const rootSelector = '#vitals-cart_drawer-container';
  const offerSelector = '.Vtl-CartDrawerUpsellSuggestionsProducts';
  let expanded = false, timer, request = 0, signature = '', wasOpen = false, latestCart;
  const money = (value, currency) => new Intl.NumberFormat(c.locale, {style:'currency',currency}).format(value / 100);
  function shippingNotice(total, currency) {
    if (total < 6000) return c.freeShippingBase;
    if (total < 9900) return c.freeShippingRemaining.replace('__amount__', money(9900 - total, currency));
    return c.freeShippingReached;
  }
  function updateShippingNotice(root) {
    if (!c.freeShippingBase || !c.freeShippingRemaining || !c.freeShippingReached) return;
    if (!latestCart || c.country !== 'DE' || latestCart.currency !== 'EUR' || !latestCart.requires_shipping) return;
    const text = shippingNotice(latestCart.total_price, latestCart.currency);
    root.querySelectorAll('.Vtl-CartDrawerBar li > span').forEach(notice => {
      if (!/kostenlose[nm]? Versand|versandkostenfrei|free shipping|spedizione gratuita/i.test(notice.textContent)) return;
      if (notice.textContent !== text) notice.textContent = text;
    });
  }
  function policy(panel) {
    const p = document.createElement('p');
    const a = document.createElement('a');
    a.href = c.policyUrl || '/policies/shipping-policy';
    a.textContent = c.policyTitle;
    p.append(a); panel.append(p);
  }
  function row(dl, label, value, total) {
    const div = document.createElement('div');
    div.className = 'sw-cost-row' + (total ? ' sw-cost-total' : '');
    const dt = document.createElement('dt'), dd = document.createElement('dd');
    dt.textContent = label; dd.textContent = value;
    div.append(dt, dd); dl.append(div);
  }
  async function update(root) {
    const checkout = root.querySelector('.Vtl-CartDrawerCheckout');
    if (!checkout) return;
    let panel = root.querySelector('.sw-cart-costs');
    if (!panel) { panel = document.createElement('div'); panel.className = 'sw-cart-costs'; checkout.prepend(panel); }
    positionCosts(root);
    const current = ++request;
    panel.replaceChildren(); panel.setAttribute('aria-busy','true');
    try {
      const response = await fetch(c.cartUrl, {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (current !== request || !panel.isConnected) return;
      latestCart = cart;
      updateShippingNotice(root);
      panel.replaceChildren(); panel.hidden = cart.item_count === 0;
      if (!cart.item_count) return;
      const dl = document.createElement('dl'); panel.append(dl);
      row(dl, c.subtotal, money(cart.total_price,cart.currency));
      policy(panel);
    } catch (_) {
      if (current === request && panel.isConnected) { panel.replaceChildren(); policy(panel); }
    } finally { if (current === request) panel.removeAttribute('aria-busy'); }
  }
  function positionCosts(root) {
    const panel = root.querySelector('.sw-cart-costs');
    const checkout = root.querySelector('.Vtl-CartDrawerCheckout');
    const content = root.querySelector('.Vtl-CartDrawer__Container-Content');
    if (!panel || !checkout || !content) return;
    if (window.matchMedia('(max-width: 768px)').matches) {
      if (panel.parentElement !== content) {
        const bottom = content.querySelector('.Vtl-CartDrawer__Container-Content-BottomContainer');
        content.insertBefore(panel, bottom && bottom.parentElement === content ? bottom : null);
      }
    } else if (panel.parentElement !== checkout) checkout.prepend(panel);
  }
  function sync() {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    positionCosts(root);
    updateShippingNotice(root);
    root.querySelectorAll(offerSelector).forEach((section,index) => {
      const hasOffer = !!section.querySelector('.Vtl-CartDrawerUpsellsSuggestionProduct');
      let button = section.previousElementSibling;
      if (!button || !button.classList.contains('sw-cart-extras-toggle')) {
        button = document.createElement('button');
        button.type = 'button'; button.className = 'sw-cart-extras-toggle';
        section.before(button);
        button.addEventListener('click',() => { expanded = !expanded; sync(); });
      }
      if (!section.id) section.id = 'sw-cart-extras-' + index;
      const collapsed = String(!expanded);
      if (section.getAttribute('data-sw-collapsed') !== collapsed) section.setAttribute('data-sw-collapsed',collapsed);
      button.hidden = !hasOffer;
      button.setAttribute('aria-controls',section.id);
      button.setAttribute('aria-expanded',String(expanded));
      const label = expanded ? c.hide : c.extras;
      if (button.textContent !== label) button.textContent = label;
    });
    const open = !!root.querySelector('.Vtl-CartDrawer__Container--IsVisible');
    const items = root.querySelector('.Vtl-CartDrawerProducts');
    const checkout = root.querySelector('.Vtl-CartDrawerCheckout__CheckoutButtonContainer');
    const next = (items ? items.textContent : '') + (checkout ? checkout.textContent : '');
    if (open && (!wasOpen || next !== signature || !root.querySelector('.sw-cart-costs'))) {
      clearTimeout(timer); timer = setTimeout(() => update(root),250); signature = next;
    }
    wasOpen = open;
  }
  function ingredientLink() {
    const info = document.querySelector('[id^="product-info-"]');
    if (!info || info.querySelector('.sw-ingredient-link')) return;
    const scope = document.getElementById('main-content') || document.querySelector('main');
    if (!scope) return;
    const target = Array.from(scope.querySelectorAll('p,h2,h3,h4,td,th')).find(el => /^(zutaten|ingredients|ingredienti)\s*[:：]/i.test(el.textContent.trim()));
    const form = info.querySelector('product-form');
    if (!target || !form) return;
    target.id = target.id || 'sw-product-ingredients';
    target.classList.add('sw-ingredient-target');
    const link = document.createElement('a');
    link.className = 'sw-ingredient-link'; link.href = '#' + target.id; link.textContent = c.ingredients;
    form.before(link);
    link.addEventListener('click',() => {
      for (const detail of Array.from(scope.querySelectorAll('details'))) if (detail.contains(target)) detail.open = true;
      const panel = target.closest('[role="tabpanel"]');
      if (panel) {
        const tab = Array.from(scope.querySelectorAll('[role="tab"]')).find(el => el.getAttribute('aria-controls') === panel.id);
        if (tab) tab.click();
      }
      requestAnimationFrame(() => { target.setAttribute('tabindex','-1'); target.focus({preventScroll:true}); target.scrollIntoView({behavior:'smooth',block:'start'}); });
    });
  }
  new MutationObserver(sync).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('change',e => { if (e.target.closest(rootSelector)) { signature = ''; sync(); } });
  window.matchMedia('(max-width: 768px)').addEventListener('change', sync);
  sync(); ingredientLink();
})();
